import React, { useEffect, useState } from 'react'
import { accessor, formatDateToMainUTC } from '../../helpers';
import { Input } from '../../components/Input';
import { Select } from '../../components/Select';
import { useDispatch, useSelector } from 'react-redux';
import { Popup } from '../../components/Popup';
import { Button } from '../../components/Button';
import { createOrderDep } from '../../redux/orderSlice';

export const CreateOrderDep = ({closeFn, isWarranty, cityUTC, order}) => {

    const depsDataDefault = {orderData: {orderComment: '', date: {min: null, max: null}}, orderOwner: null}
    const [depsData, setDepsData] = useState(depsDataDefault);

    const dispatch = useDispatch();

    const createOrderDepHandler = () => {
        const {orderData, orderOwner} = depsData
        if (orderData.orderComment && orderData.date.min && orderData.date.max && orderOwner) {
            dispatch(createOrderDep({
                orderData: {
                    ...orderData,
                    _id: order._id
                },
                orderOwner,
                isWarranty,
                closeFn
            }));
        }
    }

    const [comment, setComment] = useState(depsData.orderData.orderComment);
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [isInterval, setInterval] = useState(false);

    const users = useSelector((state) => state.users.list);
    const thisUserId = useSelector((state) => state.auth.id);
    const usersCanCreateOrder = users.filter(accessor.createOrder);

    const [orderOwner, setOrderOwner] = useState(thisUserId);

    useEffect(() => {
        const formatTime = formatDateToMainUTC(date, time, cityUTC);
        setDepsData({
            orderData: {
                orderComment: comment,
                date: formatTime,
            },
            orderOwner
        })
    }, [comment, date, time, isInterval]);

    const repeatsCount = order.details.repeats?.length || 0;
    const orderTypeStr = isWarranty ? 'гарантию' : `П${repeatsCount+1}`;
    const popupTitle = `Создать ${orderTypeStr} по заявке id${order.id}`
    return (
        <Popup title={popupTitle} closeFn={closeFn} button={<Button text={`Создать ${orderTypeStr}`} onClick={createOrderDepHandler} />}>
            <div className='create-order-dep'>
                <div className='create-order-dep__column'>
                    <span>Коммент</span>
                    <textarea className='textarea-input dark-theme-bg0' value={comment} onChange={(e) => setComment(e.target.value)}></textarea>
                </div>
                <div className='create-order-dep__column'>
                    <div className='create-order-dep__option'>
                        <span>Дата</span>
                        <input type="date" value={date} onChange={(e) => setDate(e.target.value)}/>
                    </div>
                </div>
                <div className='create-order-dep__column'>
                    <div className='create-order-dep__option'>
                        <span>Время</span>
                        <Input centered={true} value={time} changeHandler={(e) => setTime(e.target.value)}/>
                    </div>
                    
                </div>
                <div className='create-order-dep__column'>Создать от имени:
                        <Select
                        className="cell"
                        enums={usersCanCreateOrder}
                        value={orderOwner}
                        changeHandler={(evt) => setOrderOwner(evt.target.value)}
                    />
                    </div>
            </div>
        </Popup>
    )
}
